import React from "react";
import HelpDeskUser from "../Components/HelpDesk/HelpDeskUser";

const HelpDeskUserPage: React.FC = () => {
  return (
    <div>
      <HelpDeskUser />
    </div>
  );
};

export default HelpDeskUserPage;
